import { MenuButton } from 'components'
import Flex from 'components/priority/Flex/Flex'
import Icon from 'components/priority/Icon/Icon'
import Text from 'components/priority/Text/Text'
import { TableFilter } from './'
import { useTranslation } from 'react-i18next'

export const TableControls = ({
  getTableProps,
  nextPage,
  pageIndex,
  pageOptions,
  preGlobalFilteredRows,
  previousPage,
  searchPlaceholder,
  setGlobalFilter,
  showingArchived,
  state,
  toggleArchived,
}) => {
  const { t } = useTranslation()
  return (
    <Flex justify="space-between" align="center" margin="0 0 20px 0">
      <Flex>
        {/* recent or archived dropdown — only shows if showingArchived exists */}
        {showingArchived !== undefined && (
          <MenuButton
            margin="0 16px 0 0"
            text={
              showingArchived ? t('dashboard.archived') : t('dashboard.recent')
            }
            items={[
              {
                text: t('dashboard.recent'),
                onClick: () => toggleArchived(false),
              },
              {
                text: t('dashboard.archived'),
                onClick: () => toggleArchived(true),
              },
            ]}
          />
        )}

        {/* filter input — Only shows if setGlobalFilter is declared */}
        {setGlobalFilter && (
          <TableFilter
            globalFilter={state.globalFilter}
            preGlobalFilteredRows={preGlobalFilteredRows}
            setGlobalFilter={setGlobalFilter}
            searchPlaceholder={searchPlaceholder}
            {...getTableProps()}
          />
        )}
      </Flex>

      {/* page navigation */}
      <Flex>
        <Text margin="0 14px 0 0">
          {t('table.page')} {pageIndex + 1} {t('table.of')} {pageOptions.length}
        </Text>
        <Icon
          icon="chevronLeft"
          onClick={() => previousPage()}
          fill={pageIndex === 0 ? 'gray4' : 'gray2'}
          margin="0 24px 0 0"
          clickable={pageIndex !== 0}
        />
        <Icon
          icon="chevronRight"
          onClick={() => nextPage()}
          fill={pageIndex === pageOptions.length - 1 ? 'gray4' : 'gray2'}
          clickable={pageIndex !== pageOptions.length - 1}
        />
      </Flex>
    </Flex>
  )
}

export default TableControls
